var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1881 28.4029L30.0701 28.3203L29.9828 28.4348C28.1666 30.8164 25.9488 32.8146 23.3691 34.389L23.2432 34.4658L23.3179 34.5929C24.1962 36.0891 24.8845 37.683 25.3712 39.3575L25.4101 39.4914L25.5465 39.4623C29.792 38.5556 33.5181 36.2255 36.1951 32.8024L36.2925 32.6779L36.163 32.5872L30.1881 28.4029Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6741 33.9636L20.8354 33.8843L20.7285 33.7398C19.7011 32.3511 18.509 31.1237 17.1656 30.0734L17.0411 29.976L16.9504 30.1055L12.8744 35.9258L12.6866 36.194L13.0123 36.1611C15.6634 35.8935 18.2682 35.147 20.6741 33.9636Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8404 37.7601L13.346 37.8242L13.7936 38.0436C16.8071 39.5208 20.174 40.1192 23.5502 39.7751L23.7317 39.7566L23.6785 39.5821C23.232 38.1197 22.619 36.7229 21.8429 35.4127L21.7714 35.2919L21.6461 35.3553C19.1937 36.5956 16.5476 37.4093 13.8404 37.7601Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1551 16.1138L39.3591 16.1137L39.2982 15.919C38.3923 13.0234 36.7818 10.4072 34.6189 8.31712L34.2582 7.9686L34.3683 8.45792C34.8883 10.769 35.0673 13.1561 34.8949 15.5069L34.8854 15.6365L35.0123 15.6644C36.3805 15.9655 37.7654 16.114 39.1551 16.1138Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2296 22.8285L22.1067 22.7424L22.0207 22.8653L18.0965 28.4689L18.0145 28.5859L18.1274 28.6735C19.6945 29.8878 21.0765 31.32 22.249 32.9503L22.33 33.0629L22.4485 32.991C24.849 31.5366 26.915 29.6892 28.6078 27.4865L28.7034 27.3621L28.5749 27.2722L22.2296 22.8285Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1363 31.1987L37.266 31.2896L37.3497 31.155C39.8013 27.2118 40.6783 22.4794 39.8015 17.9185L39.7775 17.7937L39.6505 17.7969C38.0434 17.837 36.4333 17.6864 34.8462 17.3542L34.6919 17.3219L34.6673 17.4777C34.1452 20.7898 32.9345 23.9798 31.1211 26.8106L31.0435 26.9318L31.1614 27.0144L37.1363 31.1987Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5819 8.21998L32.5012 7.90323L32.3137 8.17097L28.9298 13.003L28.839 13.1326L28.9733 13.2163C30.2406 14.0064 31.6091 14.6422 33.0554 15.1229L33.2421 15.185L33.2525 14.9885C33.3725 12.7235 33.1445 10.4279 32.5819 8.21998Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14752 24.6855L9.31046 24.7996L9.35579 24.5749C9.95332 21.6124 11.0729 18.845 12.69 16.3241L12.7678 16.2028L12.6498 16.1202L6.67491 11.9359L6.54538 11.8452L6.46163 11.9793C4.16009 15.6653 3.24435 19.9635 3.84375 24.2632L3.86303 24.4015L4.00234 24.3921C5.72932 24.2764 7.45157 24.3762 9.14752 24.6855Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6257 14.7315L13.7436 14.8141L13.831 14.6997C15.8713 12.0277 18.4532 9.79796 21.389 8.1764L21.5272 8.10011L21.444 7.96602C20.5892 6.58804 19.8978 5.12987 19.3855 3.60261L19.3451 3.48203L19.2195 3.50222C14.6323 4.2396 10.4864 6.6797 7.61891 10.3317L7.52107 10.4564L7.65084 10.5472L13.6257 14.7315Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2113 8.6579L24.0305 8.73472L24.1522 8.88889C25.0972 10.086 26.1641 11.1526 27.3397 12.0733L27.4643 12.1709L27.5551 12.0413L30.939 7.20932L31.1265 6.94158L30.8012 6.97402C28.534 7.20014 26.2988 7.7708 24.2113 8.6579Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2334 34.9153L11.3138 35.2326L11.5016 34.9644L15.5776 29.1442L15.6683 29.0147L15.5342 28.9309C14.0879 28.0276 12.5269 27.327 10.8706 26.8362L10.6983 26.7852L10.6789 26.9639C10.3894 29.6295 10.5784 32.3324 11.2334 34.9153Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2648 17.2513L14.1363 17.1614L14.0522 17.2937C12.5609 19.6376 11.5312 22.2107 10.9851 24.9638L10.9581 25.0997L11.0915 25.1373C13.0266 25.6832 14.8463 26.4903 16.5216 27.5496L16.6426 27.6261L16.7247 27.5089L20.6489 21.9054L20.7349 21.7825L20.6121 21.6964L20.6101 21.695L14.2648 17.2513Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.37326 26.0632L4.19108 26.0727L4.23565 26.2496C5.06523 29.5422 6.78009 32.4995 9.19858 34.8264L9.55778 35.172L9.44897 34.6855C8.85303 32.0215 8.71446 29.2547 9.04018 26.5279L9.05681 26.3887L8.91905 26.3627C7.42023 26.0799 5.89661 25.9834 4.37326 26.0632Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4988 13.5571L26.3769 13.4718C24.95 12.3643 23.6686 11.0655 22.5566 9.59192L22.479 9.48902L22.3655 9.55031C19.5859 11.0526 17.1387 13.14 15.2093 15.6506L15.1137 15.775L15.2421 15.8649L21.5875 20.3086L21.7103 20.3947L21.7964 20.2718L26.4127 13.68L26.4988 13.5571Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8553 14.5572L27.9772 14.6425C29.5058 15.6048 31.1644 16.3649 32.9294 16.9061L33.0526 16.9439L33.0338 17.0714C32.5723 20.1972 31.4474 23.2106 29.7477 25.8821L29.6636 26.0144L29.5351 25.9245L23.1898 21.4808L23.0669 21.3947L23.153 21.2719L27.7693 14.6801L27.8553 14.5572Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0337 5.10282L30.024 5.09603L30.0134 5.09085C27.3098 3.77281 24.3007 3.15389 21.2698 3.29251L21.0662 3.30183L21.1357 3.49348C21.6086 4.79817 22.2217 6.04892 22.9744 7.23321L23.044 7.34266L23.1624 7.28963C25.3146 6.32527 27.6192 5.6773 29.9688 5.37587L30.3532 5.32655L30.0357 5.10422L30.0337 5.10282Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/Web.7154d38dadec0562960abc754dce754a.svg";
export { ForwardRef as ReactComponent };